var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldMessageAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.17 14.672a4.008 4.008 0 0 0 0 5.66c.53.53 1.18.88 1.87 1.05.38.1.78.13 1.18.11.95-.04 1.88-.42 2.61-1.15a3.98 3.98 0 0 0 1.05-3.79c-.16-.69-.52-1.34-1.05-1.87a3.952 3.952 0 0 0-2.62-1.17c-1.09-.07-2.21.33-3.04 1.16zm4.85 3.34c-.14.14-.32.22-.53.22h-.74v.78c0 .21-.08.39-.22.53s-.32.22-.53.22c-.41 0-.75-.34-.75-.75v-.78H3.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h.75v-.71c0-.41.34-.75.75-.75s.75.34.75.75v.71h.74a.749.749 0 0 1 .53 1.28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75 2.43C4.9 2.43 3 4.33 3 7.18v4.46c0 .35.36.6.7.51.42-.1.85-.15 1.3-.15 2.86 0 5.22 2.32 5.48 5.13.02.28.25.5.52.5h.55l4.23 2.82c.62.42 1.47-.04 1.47-.8v-2.02c1.42 0 2.61-.48 3.44-1.3.83-.84 1.31-2.03 1.31-3.45v-5.7c0-2.85-1.9-4.75-4.75-4.75h-9.5zm1.42 8.38a.715.715 0 0 1 0-1.43h6.66a.715.715 0 0 1 0 1.43H9.17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldMessageAdd);
export default __webpack_public_path__ + "static/media/vuesax-bold-message-add.aa4351f1557dff6a327aa32ddc7998ff.svg";
export { ForwardRef as ReactComponent };